import React, { useEffect, useState } from 'react'
import './index.scss'
import Navigation from '@App/navigation'
import { TipaltiIframe } from '@Entities/rightsholder'

interface TipaltiIFrameProps {
    tipaltiIFrame: TipaltiIframe
    setPreloaderIsOpen: (preloaderIsOpen: boolean) => void
}

const TipaltiIFrame = (props: TipaltiIFrameProps) => {
    const { tipaltiIFrame, setPreloaderIsOpen } = props

    const [iframeHeight, setIframeHeight] = useState(0)

    const tipaltiHandler = (evt: any) => {
        if (evt.data && evt.data.TipaltiIframeInfo && evt.data.TipaltiIframeInfo.height) {
            setIframeHeight(evt.data.TipaltiIframeInfo.height)
        }
    }

    useEffect(() => {
        window.addEventListener('message', tipaltiHandler, false)
    }, [])

    return (
        <>
            {tipaltiIFrame.url ? (
                <iframe
                    className="tipalti-iframe-mlc"
                    title="Tipalti Iframe"
                    height={iframeHeight}
                    frameBorder={0}
                    allowFullScreen
                    src={tipaltiIFrame.url}
                    onLoad={() => setPreloaderIsOpen(false)}
                />
            ) : tipaltiIFrame.message ? (
                <p>
                    To reduce potential for fraud, once you have reached your monthly earnings threshold, you will need
                    to reach out to our support team to make any changes to your banking information. You can do
                    so&nbsp;
                    <a className="link" href={Navigation.contactUs.root()}>
                        here.
                    </a>
                </p>
            ) : (
                <></>
            )}
        </>
    )
}

export default TipaltiIFrame
